import { getRequest } from '@/core';
import { edi } from '@/requests';

export default async function(edipartId) {
	let url = edi.getEdipartDetails(edipartId);
	let response = await getRequest(url);
	return response;
}